import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            padding: 2px 0;
            @media (min-width: 992px) and (max-width: 1180px) {
                max-width: 50% !important;
                flex-basis: 50% !important;
            }
        `,
    },
    cardDivider: {
        css: css`
            padding: 0px 2px;
            height: 100%;
            width: 100%;
            overflow: hidden;
        `,
    },
});
